module.exports = __webpack_public_path__ + "static/media/Commercial-2.68e598cd.jpg";